import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {

  protected _compare (item, property, criteria): boolean {
    if (!item) {
      return true
    }
    return {
      function: () => criteria(item, property, item[property]),
      string: () => {
        try {
          return RegExp(criteria, 'i').test(item[property])
        } catch (e) {
          return ~item[property].indexOf(criteria)
        }
      },
      number: () => /^(((>>?>?|<<?|==?|!=|\+|\-|\*\*?|\/|%|&|\||\^)=?)|(~=|&&|\|\||=!))$/.test(property) ?
        // tslint:disable-next-line:no-eval
        eval(item + property + criteria) : // Operators (comparison, bitwise, arithmetic, boolean)
        item[property] === criteria,
      boolean: () => /^(((>>?>?|<<?|==?|!=|\+|\-|\*\*?|\/|%|&|\||\^)=?)|(~=|&&|\|\||=!))$/.test(property) ?
        // tslint:disable-next-line:no-eval
        eval(item + property + criteria) : // Operators (comparison, bitwise, arithmetic, boolean)
        item[property] === criteria,
      object: () => criteria instanceof Array ?
        criteria.reduce(
            (equal, prop) => equal || this._compare(item, property, prop)
          , false) :
        Object.keys(criteria).reduce(
            (equal, prop) => equal && this._compare(item[property], prop, criteria[prop])
          , true),
      undefined: () => true,
      symbol: () => true
    }[typeof criteria]()
  }

  protected _filter(value: any[], property: string, criteria) {
    if (value instanceof Array) {
      return value.filter(item => this._compare(item, property, criteria))
    } else {
      return value
    }
  }

  transform(value: any[], property, criteria?): any[] {
    return {
      string: () => this._filter(value, property, criteria),
      number: () => this._filter(value, property, criteria),
      boolean: () => property ? value : [],
      function: () => value.filter(
        criteria instanceof Array ? property(value, ...criteria) : property(value, criteria)
      ),
      object: () => property instanceof Array ?
        property.reduce((result, prop) => this.transform(result, prop, criteria), value) :
        Object.keys(property).reduce(
          (result, prop) => this._filter(result, prop, property[prop])
          , value
        ),
      symbol: () => value,
      undefined: () => value,
    }[typeof property]()
  }
}
